import React, { useState, useEffect }   from "react";
import { useNavigate }                  from "react-router-dom";
import eventBus                         from "../common/EventBus";
import Logo                             from '../images/logo_bianco_intero.png';
import iconSpain                        from '../images/icon-spain.svg';
import iconItaly                        from '../images/icon-italy.svg';
import iconUK                           from '../images/icon-uk.svg';
import axios                            from "axios";
import VisibilityIcon                   from "@mui/icons-material/Visibility";
import VisibilityOffIcon                from "@mui/icons-material/VisibilityOff";
import SearchIcon                       from "@mui/icons-material/Search";
import { useTranslation }               from 'react-i18next';


import {
    Autocomplete,
    Box,
    Button,
    Grid,
    IconButton,
    InputAdornment,
    Snackbar,
    TextField,
    Typography,
    Alert,
} from "@mui/material";

const RegisterComponent = () => {

    const {t, i18n} = useTranslation();
    

    const navigate = useNavigate();

    const [commercialiOptions,              setCommercialiOptions               ] = useState([]);
    const [username,                        setUsername                         ] = useState("");
    const [password,                        setPassword                         ] = useState("");
    const [pIva,                            setPIva                             ] = useState("");
    const [ragioneSociale,                  setRagioneSociale                   ] = useState("");
    const [paese,                           setPaese                            ] = useState("");
    const [indirizzo,                       setIndirizzo                        ] = useState("");
    const [personaContatto,                 setPersonaContatto                  ] = useState("");
    const [emailPersonaContatto,            setEmailPersonaContatto             ] = useState("");
    const [telefono,                        setTelefono                         ] = useState("");
    const [commerciale,                     setCommerciale                      ] = useState("");
    const [commercialeSelected,             setCommercialeSelected              ] = useState(null);
    const [lingua,                          setLingua                           ] = useState(null);
    const [showPassword,                    setShowPassword                     ] = useState(false);
    const [customerData,                    setCustomerData                     ] = useState(null);
    const [snackbarOpen,                    setSnackbarOpen                     ] = useState(false);
    const [snackbarMessage,                 setSnackbarMessage                  ] = useState("");
    const [snackbarSeverity,                setSnackbarSeverity                 ] = useState("info"); 
    const [idRiba,                          setIdRiba                           ] = useState("");
    const [loginError,                      setLoginError                       ] = useState({
        username:                           false,
        password:                           false,
        pIva:                               false,
        ragioneSociale:                     false,
        personaContatto:                    false,
        emailPersonaContatto:               false,
        telefono:                           false,
        commerciale:                        false,
        paese:                              false,
        indirizzo:                          false,
    });

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const headers = '4w.UF.A2tsuj54jkdg325:!kopSAT';

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            sessionStorage.removeItem("user");
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    const handlePIvaSearch = async () => {
        if (pIva) {
            try {
                const response = await axios.get(
                    // "https://marvinapi-preprod.azurewebsites.net/api/SAT/GetCustomerFromVAT",
                    `api/auth/login/piva/${pIva}`
                    // {
                    //     headers: {
                    //         Authorization: headers,
                    //         VATNumber: pIva,
                    //         Cookie: 'ARRAffinity=bfc182fe46a87aff3e3143aeb2efacc573fc1df446250053af04cb513db66771; ARRAffinitySameSite=bfc182fe46a87aff3e3143aeb2efacc573fc1df446250053af04cb513db66771'
                    //     },
                    // }
                );

                if (response.data?.code === 200) {
                    setCustomerData(response.data);
                    const { IDCustomerRMT } = response.data.result;
                    const { CompanyName } = response.data.result;
                    setRagioneSociale(CompanyName);
                    setIdRiba(IDCustomerRMT);
                    setSnackbarSeverity("success");
                    setSnackbarMessage(t('Cliente trovato con successo: {{companyName}}', { companyName: CompanyName }));
                    setSnackbarOpen(true);
                } else {
                    setPIva("");
                    setSnackbarSeverity("warning");      
                    setSnackbarMessage(t('Cliente non trovato con la partita IVA specificata.'));
                    setSnackbarOpen(true);
                }
            } catch (error) {
                console.error("Errore durante il recupero del cliente:", error);
                setPIva("");
                setSnackbarSeverity("error");
                setSnackbarMessage(t('Cliente non trovato con la partita IVA specificata.'));
                setSnackbarOpen(true);
            }
        }
    };


    useEffect(() => {
        const fetchRegister = async () => {
            try {
                const commercialiResponse = await axios.get("commerciale")
                if (Array.isArray(commercialiResponse.data)) {
                    const formattedCommerciali = commercialiResponse.data.map(commerciale => ({
                        id: commerciale.id,
                        label: `${commerciale.nome} ${commerciale.cognome}`,
                        ...commerciale
                    }));
                    setCommercialiOptions(formattedCommerciali);
                } else {
                    console.error("I dati ottenuti non sono validi:", commercialiResponse.data);
                }
            } catch (error) {
                console.error("Errore nel recupero dei dati", error);
            }
        };
        fetchRegister();
    }, []);


    useEffect(() => {
        if ((username && !emailRegex.test(username)) || (emailPersonaContatto && !emailRegex.test(emailPersonaContatto))) {
            setLoginError((errors) => ({ ...errors, username: true, emailPersonaDiContatto: true }));
        } else {
            setLoginError((errors) => ({ ...errors, username: false, emailPersonaDiContatto: false }));
        }
    }, [username, emailPersonaContatto]);

    useEffect(() => {
        const lastRegisteredUsername = sessionStorage.getItem("lastRegisteredUsername");
        if (lastRegisteredUsername) {
            setUsername(lastRegisteredUsername);
            sessionStorage.removeItem("lastRegisteredUsername");
        }
    }, []);




    const handleRegister = async (e) => {
        if (e) {
            e.preventDefault();
        }
        try {
            const response = await axios.post("/api/auth/signup", {
                username,
                password,
                pIva,
                ragioneSociale,
                personaContatto,
                emailPersonaContatto,
                telefono,
                commerciale,
                paese,
                indirizzo,
                idRiba,
                lingua: lingua?.value
            });

            if (response.status === 200) {
                eventBus.dispatch("RegisterSuccess");
                setSnackbarSeverity("success");
                setSnackbarMessage(t(`Registrazione avvenuta con successo`));
                setSnackbarOpen(true);
                setTimeout(() => {
                    navigate("/login");
                }, 4000);
            } else {
                setSnackbarSeverity("warning");
                setSnackbarMessage(t("Errore nella Registrazione!"));
                setSnackbarOpen(true);
            }
        } catch (error) {
            console.error("Errore durante la registrazione:", error);
            if (error.response && error.response.data) {
                const errorMessage = error.response.data.message;
                if (errorMessage.includes("username")) {
                    setLoginError((errors) => ({ ...errors, username: true }));
                } else if (errorMessage.includes("password")) {
                    setLoginError((errors) => ({ ...errors, password: true }));
                } else {
                    setLoginError({ username: true, password: true });
                }
            }
        }
    };

    const handleKeyDown = (e) => {
        if (e.keyCode === 13) {
            handleRegister();
        }
    };

    const handleLogin = () => {
        navigate("/login");
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const handleLanguageChange = (newValue) => {
        if (newValue) {
            setLingua(newValue);
            i18n.changeLanguage(newValue.value); 
        }
    };
    

    const languageOptions = [
        { value: 'it', label: t('Italian'), flag: iconItaly },
        { value: 'es', label: t('Spanish'), flag: iconSpain },
        { value: 'en', label: t('English'), flag: iconUK },
    ];
    
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '80vh',
                width: '80vw',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                borderRadius: '20px',
                boxShadow: 3,
                overflowY: 'auto'
            }}
        >
            {/* Box per il login (sinistra) */}
            <Box
                sx={{
                    width: '20%',
                    height: '100%',
                    flex: 1,
                    padding: 4,
                    display: { xs: 'none', lg: 'flex' },
                    flexDirection: 'column',
                    bgcolor: '#263F78',
                    color: 'white',
                    borderRadius: '8px 0 0 8px',
                    boxSizing: 'border-box',
                }}
            >
                <Box
                    component="img"
                    src={Logo}
                    alt="Logo"
                    sx={{ width: 200, height: 'auto', mb: 2 }}
                />
                <Box sx={{ flexGrow: 0.4 }} />
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                }}>
                   <Typography variant="h2" mb={1} sx={{ fontWeight: 'bold' }}>
                   {t('welcome back!')}
                   </Typography>
                   <Typography mb={1} pl={3} pr={3}>
                        {t('Already have an account?')}
                    </Typography>
                    <Button
                        onClick={handleLogin}
                        variant="outlined"
                        sx={{
                            width: '60%',
                            color: 'white',
                            borderColor: 'white',
                            borderRadius: '20px',
                            fontWeight: 'bold',
                            "&:hover": {
                                bgcolor: 'white',
                                color: '#263F78',
                                transform: 'scale(1.02)'
                            }
                        }}
                    >
                        {t('Sign In')}
                    </Button>
                </Box>
            </Box>

            <Box
                sx={{
                    width: { xs: '80%', lg: '60%' },
                    padding: 6,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    maxHeight: '100%'
                }}
            >
                <Typography variant="h2" sx={{ fontWeight: 'bold', color: '#263F78', my: { xs: 4, lg: 2 } }}>
                    {t('Create Account')}
                </Typography>
                <Grid container spacing={2} sx={{ width: '100%' }}>
                    <Grid item xs={6}>
                        <TextField
                            label={t('Email')}
                            variant="filled"
                            fullWidth
                            required
                            value={username}
                            onKeyDown={handleKeyDown}
                            error={loginError.username}
                            onChange={(e) => {
                                setUsername(e.target.value);
                                setLoginError((errors) => ({ ...errors, username: false }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label={t('Password')}
                            variant="filled"
                            type={showPassword ? 'text' : 'password'}
                            fullWidth
                            required
                            autoComplete="current-password"
                            value={password}
                            onKeyDown={handleKeyDown}
                            error={loginError.password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setLoginError((errors) => ({ ...errors, password: false }));
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={togglePasswordVisibility}
                                            edge="end"
                                            tabIndex={-1} //per evitare che venga selezionata l'icona quando si preme TAB
                                        >
                                            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label={t('Partita iva')}
                            variant="filled"
                            fullWidth
                            required
                            value={pIva}
                            onKeyDown={handleKeyDown}
                            error={loginError.pIva}
                            onChange={(e) => {
                                setPIva(e.target.value);
                                setLoginError((errors) => ({ ...errors, pIva: false }));
                            }}
                            onBlur={handlePIvaSearch}
                            slotProps={{
                                input: {
                                endAdornment: (
                                    <InputAdornment position="end">
                                    <IconButton
                                        onClick={handlePIvaSearch}
                                        edge="end"
                                        aria-label="cerca partita iva"
                                    >
                                        <SearchIcon />
                                    </IconButton>
                                    </InputAdornment>
                                ),
                                }
                            }}
                            />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label={t('Ragione sociale')}
                            variant="filled"
                            fullWidth
                            required
                            value={ragioneSociale}
                            onKeyDown={handleKeyDown}
                            error={loginError.ragioneSociale}
                            onChange={(e) => {
                                setRagioneSociale(e.target.value);
                                setLoginError((errors) => ({ ...errors, ragioneSociale: false }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label={t('Indirizzo')}
                            variant="filled"
                            fullWidth
                            required
                            value={indirizzo}
                            onKeyDown={handleKeyDown}
                            error={loginError.indirizzo}
                            onChange={(e) => {
                                setIndirizzo(e.target.value);
                                setLoginError((errors) => ({ ...errors, indirizzo: false }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label={t('Paese')}
                            variant="filled"
                            fullWidth
                            required
                            value={paese}
                            onKeyDown={handleKeyDown}
                            error={loginError.paese}
                            onChange={(e) => {
                                setPaese(e.target.value);
                                setLoginError((errors) => ({ ...errors, paese: false }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label={t('Persona di contatto')}
                            variant="filled"
                            fullWidth
                            required
                            value={personaContatto}
                            onKeyDown={handleKeyDown}
                            error={loginError.personaContatto}
                            onChange={(e) => {
                                setPersonaContatto(e.target.value);
                                setLoginError((errors) => ({ ...errors, personaContatto: false }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label={t('Email persona di contatto')}
                            variant="filled"
                            fullWidth
                            required
                            value={emailPersonaContatto}
                            onKeyDown={handleKeyDown}
                            error={loginError.emailPersonaContatto}
                            onChange={(e) => {
                                setEmailPersonaContatto(e.target.value);
                                setLoginError((errors) => ({ ...errors, emailPersonaContatto: false }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label={t('Cellulare')}
                            variant="filled"
                            fullWidth
                            required
                            value={telefono}
                            onKeyDown={handleKeyDown}
                            error={loginError.telefono}
                            onChange={(e) => {
                                setTelefono(e.target.value);
                                setLoginError((errors) => ({ ...errors, telefono: false }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Autocomplete
                            options={commercialiOptions}
                            getOptionLabel={(option) => `${option.nome} ${option.cognome}`}
                            value={commercialeSelected}
                            onChange={(event, newValue) => {
                                setCommerciale(newValue ? newValue.id : "");
                                setCommercialeSelected(newValue);
                                setLoginError((errors) => ({ ...errors, commerciale: false }));
                            }}
                            onInputChange={(event, newInputValue) => {
                                setCommerciale(newInputValue);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('Commerciale di riferimento')}
                                    variant="filled"
                                    fullWidth
                                    required
                                    error={loginError.commerciale}
                                    onKeyDown={handleKeyDown}
                                />
                            )}
                        />

                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            fullWidth
                            options={languageOptions}
                            getOptionLabel={(option) => option.label}
                            value={lingua}
                            // onChange={(event, newValue) => {
                            //     setLingua(newValue);
                            //     if (newValue) {
                            //         i18n.changeLanguage(newValue.value); 
                            //     }
                            // }}
                            onChange={(event, newValue) => handleLanguageChange(newValue)}
                            renderOption={(props, option) => (
                                <Box component="li" {...props} display="flex" alignItems="center">
                                    <img src={option.flag} alt={`${option.label} flag`} style={{ width: '24px', marginRight: '8px' }} />
                                    {option.label}
                                </Box>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('Lingua')}
                                    variant="filled"
                                    fullWidth
                                    sx={{ width: "100%", mb: 1 }}
                                />
                            )}
                        />
                    </Grid>
                </Grid>


                <Button
                    onClick={handleRegister}
                    variant="contained"
                    color="primary"

                    sx={{
                        bgcolor: '#263F78',
                        fontWeight: 'bold',
                        borderRadius: '40px',
                        width: '30%',
                        p: 2,
                        my: { xs: 3, lg: 2 },
                        '&:hover': {
                            bgcolor: '#263F78',
                            transform: 'scale(1.02)'
                        }
                    }}
                >
                    {t('Sign Up')}
                </Button>
                <Button
                    onClick={handleLogin}
                    variant="standard"
                    sx={{
                        display: { lg: 'none' },
                        width: '25%',
                        color: 'black',
                        borderColor: 'white',
                        borderRadius: '20px',
                        fontWeight: 'bold',
                        p: 1,
                        "&:hover": {
                            bgcolor: '#fff',
                            color: 'black',
                            borderColor: 'black',
                            transform: 'scale(1.02)'
                        }
                    }}
                >
                    {t('Back')}
                </Button>
                <Snackbar
                    open={snackbarOpen}
                    // autoHideDuration={4000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert
                        onClose={handleSnackbarClose}
                        severity={snackbarSeverity} 
                        sx={{ width: "100%" }}
                    >
                        {snackbarMessage}
                    </Alert>
                </Snackbar>

            </Box>
        </Box>
    );
};

export default RegisterComponent;
